import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CartService } from '../../../../shared/services/cart.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-cart-section',
  templateUrl: './cart-section.component.html',
  styleUrls: ['./cart-section.component.scss']
})
export class CartSectionComponent implements OnInit {
  @Input() showCart: boolean = false;
  cartItems: any[] = [];
  @Output() closeCart = new EventEmitter<void>();
  @Output() placeOrder = new EventEmitter<any>();

  showOrderModal: boolean = false;
  orderTotal: number = 0;
  totalQuantity:number = 0;
  showCheckout = false;
  orderData: any;

  constructor(private cartService: CartService ,private router: Router) { }

  ngOnInit(): void {
    this.cartService.cartItems$.subscribe(items => {
      this.cartItems = items;
      this.totalQuantity = this.calculateTotalQuantity();
    });
  }


roundToTwoDecimals(value: number): number {
  return Math.round((Number(value) + Number.EPSILON) * 100) / 100;
}

calculateTotal(): number {
  const total = this.cartItems.reduce(
    (sum, item) => sum + (Number(item.price) * Number(item.quantity)),
    0
  );

  return this.roundToTwoDecimals(total);
}

calculateTax(): number {
  const tax = this.cartItems.reduce((total, item) => {
    const itemPrice = Number(item.price) * Number(item.quantity);
    const taxRate = Number(item.sales_tax) || 0;

    return total + (itemPrice * (taxRate / 100));
  }, 0);

  return this.roundToTwoDecimals(tax);
}

calculateTotalWithTax(): number {
  return this.roundToTwoDecimals(
    this.calculateTotal() + this.calculateTax()
  );
}



  // calculateTotal(): number {
  //   return this.cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
  // }

  // calculateTax(): number {
  //   return this.cartItems.reduce((total, item) => {
  //     const itemPrice = item.price * item.quantity;
  //     const taxRate = item.sales_tax || 0;
  //     return total + (itemPrice * (taxRate / 100));
  //   }, 0);
    
  // }

//   calculateTax(): number {
//   const tax = this.cartItems.reduce((total, item) => {
//     const itemPrice = item.price * item.quantity;
//     const taxRate = item.sales_tax || 0;
//     return total + (itemPrice * (taxRate / 100));
//   }, 0);

//   return Math.round((tax + Number.EPSILON) * 100) / 100;
// }

//   calculateTotalWithTax(): number {
//     return this.calculateTotal() + this.calculateTax();
//   }

  closeCartPanel(): void {
    this.closeCart.emit();
  }

  openOrderModal(): void {
    this.orderTotal = this.calculateTotalWithTax();
    this.onPlaceOrder();
    // this.showCheckout = true;
    // this.openCheckout(data)();
  }

  closeOrderModal(): void {
    this.showCheckout = false;
  }

  // onPlaceOrder(): void {
  //   const isLoggedIn = localStorage.getItem('is_logged_in');

  //   // CHECK LOGIN
  //   if (!isLoggedIn) {
  //     // OPTIONAL MESSAGE
  //     alert('Please login to place your order');
  //     // REDIRECT TO LOGIN PAGE
  //     this.router.navigate(['/profile-authentication']);
  //     return;
  //   }
  //   this.placeOrder.emit({
  //     items: this.cartItems,
  //     total: this.orderTotal
  //   });
  //   // this.cartService.clearCart();
  //   this.closeOrderModal();
  //   this.closeCartPanel();
  // }

onPlaceOrder(): void {

  // const isLoggedIn = localStorage.getItem('is_logged_in');

  // /* CHECK LOGIN */
  // if (!isLoggedIn) {

  //   alert('Please login to place your order');

  //   this.router.navigate(['/profile-authentication']);

  //   return;
  // }

  /* SAVE ORDER DATA */
  this.orderData = {

    items: this.cartItems,

    subtotal: this.calculateTotal(),

    tax: this.calculateTax(),

    total: this.orderTotal,

    totalQuantity: this.totalQuantity,

    orderDate: new Date()

  };

  console.log('Order Data:', this.orderData);

  /* OPEN CHECKOUT MODAL */
  this.showCheckout = true;
}

  removeItem(index: number): void {
    this.cartService.removeFromCart(index);
  }

  updateQuantity(index: number, quantity: number): void {
    this.cartService.updateQuantity(index, quantity);
  }

  calculateTotalQuantity(): number {
  return this.cartItems.reduce((total, item) => total + item.quantity, 0);
}


  openCheckout(data: any) {
    this.orderData = data;
    this.showCheckout = true;
  }


}
